<template>
    <el-container>
        <el-aside width="25%">
            <h3>{{ $t("posts.edit.contactTitle") }}</h3>
            <p class="text-justify">{{ $t("posts.edit.contactText") }}</p>
        </el-aside>
        <el-container style="width: 100%;">
            <el-main>
                <el-col :span="24">
                    <el-form-item :label="$t('posts.edit.contactFirstnameLastname')">
                        <el-select
                                clearable
                                filterable
                                allow-create
                                default-first-option
                                v-model="contactSelected"
                                @change="changeValue('contact')"
                        >
                            <el-option
                                    style="text-transform:capitalize"
                                    v-for="contact in this.contacts"
                                    :key="contact.id"
                                    :value="contact.id"
                                    :label="contact.fullname"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="user.isUSH">
                    <el-form-item :label="$t('posts.edit.commercialEntityCode')">
                        <el-input v-model="post.id_externe_pdv" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.email_a_afficher" prop="email_a_afficher">
                        <el-input v-model="post.email_a_afficher" @input="changeValue('email_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.telephone_a_afficher" prop="telephone_a_afficher">
                        <el-input v-model="post.telephone_a_afficher"  @input="changeValue('telephone_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item :label="$labels.telephone_mobile_a_afficher" prop="telephone_mobile_a_afficher">
                        <el-input v-model="post.telephone_mobile_a_afficher"  @input="changeValue('telephone_mobile_a_afficher')" :value.sync="valeur"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.adresse_contact_a_afficher" prop="adresse_contact_a_afficher">
                    <el-input v-model="post.adresse_contact_a_afficher"  @input="changeValue('adresse_contact_a_afficher')" :value.sync="valeur"/>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.code_postal_contact_a_afficher" prop="code_postal_contact_a_afficher">
                    <el-input v-model="post.code_postal_contact_a_afficher"  @input="changeValue('code_postal_contact_a_afficher')" :value.sync="valeur"/>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$labels.ville_contact_a_afficher" prop="ville_contact">
                    <el-input v-model="post.ville_contact_a_afficher"  @input="changeValue('ville_contact_a_afficher')" :value.sync="valeur"/>
                  </el-form-item>
                </el-col>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { getUsers } from '@/services/users'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'PostFormContactInfo',
  props: ['create', 'post', 'idUser'],
  data () {
    return {
      contacts: [],
      contactSelected: null,
      value: '',
      chargement: true,
      hasAnnonce: false
    }
  },
  methods: {
    changeValue (elem) {
      if (elem === 'contact') {
        if (this.contactSelected) {
          const contact = this.contacts.find(x => x.id === this.contactSelected)
          if (contact) {
            this.post.contact_a_afficher = contact ? contact.fullname : ''
            this.post.email_a_afficher = contact ? contact.email : ''
            this.post.telephone_a_afficher = contact ? contact.phone : ''
            this.post.telephone_mobile_a_afficher = contact ? contact.mobile : ''
            this.post.adresse_contact_a_afficher = contact ? contact.address : ''
            this.post.code_postal_contact_a_afficher = contact ? contact.zipcode : ''
            this.post.ville_contact_a_afficher = contact ? contact.city : ''
          }
        } else {
          this.post.contact_a_afficher = ''
        }
      } else {
        if (this.post[elem] === '') {
          this.value = ''
        } else {
          this.value = this.post[elem]
        }
      }
    },
    controleContactSelectionne () {
      let contact
      for (let i = 0; i < this.contacts.length; i++) {
        if (this.contacts[i].firstname && this.contacts[i].lastname) {
          if (this.post.contact_a_afficher.includes(this.contacts[i].firstname) &&
                            this.post.contact_a_afficher.includes(this.contacts[i].lastname) &&
                            this.post.contact_a_afficher.includes(this.contacts[i].fullname)) {
            contact = this.contacts[i]
          }
        } else if (this.contacts[i].firstname && !this.contacts[i].lastname) {
          const prenom = this.post.contact_a_afficher + ' '
          if (prenom.includes(this.contacts[i].firstname) &&
                            prenom.includes(this.contacts[i].fullname)) {
            contact = this.contacts[i]
          }
        } else if (!this.contacts[i].firstname && this.contacts[i].lastname) {
          if (this.post.contact_a_afficher.includes(this.contacts[i].lastname) &&
                            this.post.contact_a_afficher.includes(this.contacts[i].fullname)) {
            contact = this.contacts[i]
          }
        }
      }
      if (contact) {
        this.post.contact_a_afficher = contact.fullname
        this.contactSelected = contact.id
      }
    }
  },
  async mounted () {
    const filtresContacts = { active: true, pagination: false }
    if (this.isSubUser) {
      // pour un simple utilisateur, sélection uniquement sur lui même
      filtresContacts.id = this.user.id
    }
    this.contacts = (await getUsers(filtresContacts)).list
    if(this.idUser) {
      this.contactSelected = this.idUser
    }
    if (this.isSubUser) {
      const contact = this.contacts[0]
      this.contactSelected = contact.id
      this.post.contact_a_afficher = contact ? contact.fullname : ''
      this.post.email_a_afficher = contact ? contact.email : ''
      this.post.telephone_a_afficher = contact ? contact.phone : ''
      this.post.telephone_mobile_a_afficher = contact ? contact.mobile : ''
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    ...mapGetters('postEditImmo', ['getIdContactManagePost']),
    ...mapState('postEditImmo', ['idContactManagePost']),
    valeur () {
      const val = this.value
      this.value = ''
      return val
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    post () {
      if (this.post.contact_a_afficher && !this.hasAnnonce) {
        this.hasAnnonce = true
        this.contactSelected = this.idContactManagePost
        this.controleContactSelectionne()
      }
    }
  }
}
</script>

<style scoped>

</style>
